import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  repository = new CreateRepository();
  educationChannel = new Subject();
  rumpunChannel = new Subject();
  listJabatanChannel = new Subject();
  employeeChannel = new Subject();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.rumpunChannel.next({ status: apiResponse.INITIAL });
    this.educationChannel.next({ status: apiResponse.INITIAL });
    this.listJabatanChannel.next({ status: apiResponse.INITIAL });
    this.employeeChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEducation = async (query) => {
    try {
      this.educationChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEducation(query)
        .then((result) => {
          this.educationChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.educationChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
  fetchRumpun = async (query) => {
    try {
      this.rumpunChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRumpun(query)
        .then((result) => {
          this.rumpunChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rumpunChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchListJabatan = async (query) => {
    try {
      this.listJabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchListJabatan(query)
        .then((result) => {
          this.listJabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listJabatanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchEmployee = async (query) => {
    try {
      this.employeeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployee(query)
        .then((result) => {
          this.employeeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default CreateBloc;
